import React from 'react'
import TestComponent from './TestComponent'
import { StyledEngineProvider } from '@mui/material/styles';

const MyComponent = () => {
  return (
    <>
   <StyledEngineProvider>
    <TestComponent/>
   </StyledEngineProvider>
    </>
  )
}

export default MyComponent
